import api from '../utils/axiosConfig';

export const getAllCompanies = async () => {
  try {
    const response = await api.get('/companies/get_all_companies/');
    return response.data.all_companies;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getAllCompaniesPanels = async () => {
  try {
    const response = await api.get('/companies/pu_admin/all_company_panel/');
    return response.data.all_companies_panels;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const uploadCompanyData = async (formData) => {
  try {
    // Note: When sending files, you need to set the Content-Type header to multipart/form-data
    const response = await api.post('/companies/pu_admin/company_upload/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};